export const staticLedgerType = {
  IN: '入金',
  OUT: '出金',
}

// todo:サーバーサイドからオブジェクトとして取得するようにする
export const LedgerItemCategory = {
  A100: '現金/券売機',
  A200: '現金/その他',
  B100: '振込/WEB決済',
  B200: '振込/銀行振込',
}

export const noteRegExp = /(?=^[^\t\n\r\f\v]+$)(?!^[ | ]+$)/
